var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_503_15073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.89992 14.7149C9.02214 14.9037 9.23696 15.0297 9.4814 15.0297C9.72585 15.0297 9.94066 14.9037 10.0666 14.7149L14.1481 8.41115C14.6962 7.563 15.0147 6.62967 15.0147 5.54818C15.011 2.42226 12.5555 0.0185547 9.4814 0.0185547C6.40733 0.0185547 3.95177 2.42226 3.95177 5.54818C3.95177 6.62967 4.27029 7.563 4.81844 8.41115L8.89992 14.7149ZM9.4814 2.38893C11.2258 2.38893 12.6407 3.80374 12.6407 5.54818C12.6407 7.29263 11.2258 8.70744 9.4814 8.70744C7.73696 8.70744 6.32214 7.29263 6.32214 5.54818C6.32214 3.80374 7.73696 2.38893 9.4814 2.38893ZM13.5333 12L9.4814 17.4L5.42955 12C4.04437 12.726 3.15918 13.8111 3.15918 15.0297C3.15918 17.2111 5.98881 18.9815 9.4814 18.9815C12.974 18.9815 15.8036 17.2111 15.8036 15.0297C15.8036 13.8111 14.9184 12.726 13.5333 12Z",
    fill: "url(#paint0_linear_503_15073)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_15073",
    x1: 9.4814,
    y1: 0.0185547,
    x2: 9.4814,
    y2: 18.9815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#541CF5",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#541CF5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_15073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.963,
    height: 18.963,
    fill: "white",
    transform: "translate(0 0.0185547)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.dae0ca48adc56d1cf34604fc77389994.svg";
export { ForwardRef as ReactComponent };